import React, {Component} from 'react';
import { Redirect } from 'react-router-dom'
import MainMenu from '../../components/menu/MainMenu';
import SimpleModal from "../../components/modal/SimpleModal";
import LoadingModal from "../../components/modal/LoadingModal";
import { Card} from 'react-bootstrap';
import './User.css';
import UserTable from './UserTable';

class User extends Component {

    constructor(props){
        super();
        this.state = {
            modal :{
                header : null,
                body : null,
                footer : null,
                show : false,
                variant : 'danger'
            },
            loadingShow : false
        }
    }

    render() {
        const {modal, loadingShow} = this.state;
        const {role} = this.props;
        if(!role.includes('DD_ACCOUNT_USER')){
            return <Redirect to='/unauthorized' />
        }
        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"account"} subMenu={"user"} role={role}/>
                        <UserTable 
                            {...this.props}
                        />
                    </Card.Body>
                </Card>
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />  
                <LoadingModal show={loadingShow} />
            </React.Fragment>
        );
      }
}
export default User;